import { render, staticRenderFns } from "./DateRecord.vue?vue&type=template&id=303c66a4"
import script from "./DateRecord.vue?vue&type=script&lang=js"
export * from "./DateRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports